export class SearchModelItems {
  id!: number;
  title!: string;
  path!: string;
}
